<template>
  <div></div>
</template>
<script>
import { mapState, mapGetters, mapActions } from "vuex";
export default {
  name: "handle-slack-webhook",
  data() {
    return {};
  },
  computed: {
    ...mapState("user", {
      user: (state) => state.user
    })
  },
  async mounted() {
    console.log("SLACK WEBHOOK DATA!");
    const slackData = JSON.parse(localStorage.slack);
    console.log(slackData);

    if (this.$route.query && this.$route.query.code) {
      const resp = await this.$http.get("/webhook/slack", {
        params: {
          code: this.$route.query.code,
          componentId: slackData.componentId,
          websiteId: slackData.websiteId,
          userId: this.user.id,
          redirectUri: slackData.redirectUri
        }
      });

      localStorage.slack = "success";

      window.location.href = slackData.redirectUri;
    }
  }
};
</script>
<style></style>
